<template>
  <div class="c-input u-w456">
    <div class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action no-margin">
      <div class="c-input u-w230 no-margin">
        <datepicker
          ref="refOptinDate"
          v-model="optinDate"
          :name="'optin_date' + inputName"
          format="yyyy/MM/dd"
          placeholder="YYYY/MM/DD"
          input-class="c-input__item c-input__item--overlay-ico"
          calendar-class="datepicker_calendar"
          :language="ja"
          @input="onOptinDateInput"
        />
        <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('optin_date')">
          <div class="c-icon c-icon--white u-wh22">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#calendar" />
            </svg>
          </div>
        </div>
        <div class="c-error c-error--balloon c-error--date">
          <div class="c-error__text"></div>
        </div>
      </div>
      <div class="c-select-time u-w200">
        <timepicker
          ref="timeSelect"
          v-model="optinTime"
          format="HH:mm"
          hour-label="時"
          minute-label="分"
          :name="'time_select' + inputName"
          placeholder="時間設定"
          advanced-keyboard
          manual-input
          auto-scroll
          :model-value="optinTime"
          @change="onOptinTimeChange"
        />
        <div class="c-error c-error--balloon c-error--time">
          <div class="c-error__text"></div>
        </div>
      </div>
    </div>

    <div class="c-error c-error--balloon">
      <div class="c-error__text"></div>
    </div>
  </div>
</template>

<script>
import Datepicker from './Datepicker.vue';
const ja = 'ja';
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'
import moment from 'moment';

export default {
  components: {
    'datepicker': Datepicker,
    'timepicker': VueTimepicker,
  },
  props: {
    value: String,
    inputName: {
      type: String,
      default: 'optin_condition',
    },
    isError: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
  },
  emits: ['change'],
  data() {
    return {
      currentValue: this.value,
      optinDate: null,
      optinTime: null,
      ja: ja,
    }
  },
  watch: {
    value: function (newValue, _oldValue) {
      this.setCurrentValue(newValue);
    }
  },
  mounted: function () {
    this.setCurrentValue(this.currentValue);
  },
  methods: {
    setCurrentValue: function (newValue) {
      this.currentValue = newValue;
      if (this.currentValue) {
        if (this.currentValue.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$/)) {
          let unixTime = Date.parse(this.currentValue);
          let date = new Date(unixTime);
          if (date) {
            this.optinDate = date;
            let hourString = '' + date.getHours();
            let minuteString = '' + date.getMinutes();
            this.optinTime = hourString.padStart(2, '0') + ':' + minuteString.padStart(2, '0');
          }
        }
      }
    },
    onOptinDateInput: function () {
      this.onValueChange();
    },
    onOptinTimeChange: function () {
      this.onValueChange();
    },
    onValueChange: function () {
      let value = null;
      // 日時
      if (this.optinDate && this.optinTime) {
        let timeString = '';
        if (typeof (this.optinTime) == 'string') {
          timeString = this.optinTime;
        } else if (typeof (this.optinTime) == 'object' && this.optinTime.HH) {
          if (!this.optinTime.mm) {
            this.optinTime.mm = '00'
          }
          timeString = `${this.optinTime.HH}:${this.optinTime.mm}`
        }

        value = moment(this.optinDate).format('YYYY-MM-DD') + ' ' + timeString + ':00';
      }
      this.currentValue = value;
      this.$emit("change", this.currentValue);
    },
    showCalendar: function (_name) {
      this.$refs.refOptinDate.$el.querySelector('input').focus();
      this.$refs.refOptinDate.showCalendar();
    },

  },
}
</script>
